import { GREATHER_THAN_3MM_KEY, IGR_TYPE_INDEX, LOAN_TYPE_INDEX, MAX_COLUMNS_IN_COMPONENT_BALANCES, MAX_SUBPRODUCTS_PER_COMPONENT } from "../Constants/ProjectReportConstants";

export const ShouldRenderPMRProjectReport = (productType, productClassification) => {
  return productType === LOAN_TYPE_INDEX || (productType === IGR_TYPE_INDEX &&
    productClassification?.includes(GREATHER_THAN_3MM_KEY));
}

export const HasExpandProductBalanceView = (components, showProductsInFullScreen) => {
  return components?.some(component => component?.subproducts.length >= MAX_SUBPRODUCTS_PER_COMPONENT)
    || components?.length > MAX_COLUMNS_IN_COMPONENT_BALANCES || showProductsInFullScreen;
}

export const getLabelDownloadingReport = (from) => {
  return from === 'project' ? 'extended_report.downloading_report' : 'extended_report.downloading_portfolio_report';
}
